const columns = [
  {
    title: "部门角色编码",
    key: "dprl_code",
    width: 200,
  },
  {
    title: "部门角色名称",
    key: "bk_expl",
  },
  {
    title: "所属部门",
    key: "dept_cn_name",
    width: 200,
  },
  {
    title: "权限配置",
    slot: "iconfontconfig",
    width: 100,
    iconClassConfig: [
      { name: "ys-iconshezhi", code: 0, status: 1, Pname: "org_deprole_config" }, // 配置
    ],
  },
  {
    title: "操作",
    slot: "iconfont",
    width: 300,
    iconClass: [
      { name: "ys-iconbianji", code: 1, status: 1, Pname: "org_deprole_edit" }, // 编辑
      {
        name: "ys-iconlajitongbeifen",
        code: -1,
        status: 1,
        Pname: "org_deprole_delete",
      }, // 删除
    ],
  },
];

export default columns;
